import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import WebpPicture from '~/components/WebpPicture.vue';
import Stats from '~/components/reactions/Stats.vue';
import Babka from '~/components/thumbnails/BabkaThumbnail.vue';
export default {
  components: {
    Babka: Babka,
    Stats: Stats,
    WebpPicture: WebpPicture,
    DdButton: function DdButton() {
      return import('~/components/DdButton.vue');
    },
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    PanelButton: function PanelButton() {
      return import('~/components/panels/PanelButton.vue');
    }
  },
  props: ['article', 'disableActions'],
  computed: {
    subscriptionStore: function subscriptionStore() {
      return useSubscriptionStore();
    },
    subscribed: function subscribed() {
      return this.subscriptionStore.subscribed;
    },
    locale: function locale() {
      return this.$i18n.locale || 'uk';
    },
    link: function link() {
      var slug = this.article.slug || this.article.id;
      return "/article/".concat(slug);
    },
    author: function author() {
      if (this.article.company) return this.article.company;
      if (this.article.author) return this.article.author;
      return {};
    },
    authorType: function authorType() {
      return this.article.company ? 'company' : 'user';
    },
    authorPic: function authorPic() {
      return this.authorType == 'company' ? this.article.company.logo : this.article.author.photo;
    },
    authorLink: function authorLink() {
      return "/".concat(this.author.slug);
    },
    isOwner: function isOwner() {
      var _this = this;
      var isOwner = false;
      if (!this.$auth.user || this.disableActions) return isOwner;
      if (this.authorType == 'user' && this.author.id == this.$auth.user.id) {
        isOwner = true;
      }
      if (this.authorType == 'company' && this.$auth.user.moders) {
        isOwner = this.$auth.user.moders.some(function (o) {
          return o.company.id == _this.author.id && o.approved;
        });
      }
      return isOwner;
    },
    canEdit: function canEdit() {
      if (!this.$auth.user || this.disableActions) return false;
      return this.isOwner || this.$auth.user.role.fullAccess;
    }
  },
  methods: {
    remove: function remove() {
      var _this2 = this;
      if (this.article.status == 'removed') {
        var title = this.article.title || this.$t('general.untitled');
        if (!window.confirm(this.$t('confirmDestroy', {
          title: title
        }))) return;
      }
      if (this.article.status == 'published') {
        var _title = this.article.title || this.$t('general.untitled');
        if (!window.confirm(this.$t('confirmRemove', {
          title: _title
        }))) return;
      }
      this.$axios.post("/publication/destroy/".concat(this.article.id)).then(function (res) {
        _this2.$emit('removed');
      }).catch(function (err) {
        console.log(err);
        _this2.$toastStore.add({
          title: _this2.$t('article.deleteErrorTitle'),
          text: _this2.$t('article.deleteErrorText'),
          icon: 'icon-ic-dismiss'
        });
      });
    },
    hide: function hide() {
      var _this3 = this;
      if (this.article.status == 'published') {
        var title = this.article.title || this.$t('general.untitled');
        if (!window.confirm(this.$t('article.confirmHide', {
          title: title
        }))) return;
      }
      this.$axios.post("/publication/draft/".concat(this.article.id)).then(function (res) {
        _this3.$emit('hidden');
      }).catch(function (err) {
        console.log(err);
        _this3.$toastStore.add({
          title: _this3.$t('article.hideErrorTitle'),
          text: _this3.$t('article.hideErrorText'),
          icon: 'icon-ic-dismiss'
        });
      });
    },
    restore: function restore() {
      var _this4 = this;
      if (this.article.originalStatus !== 'published') return true;
      this.$axios.$post('/publication/publish', {
        id: this.article.id
      }).then(function (res) {
        _this4.$emit('hidden');
      }).catch(function (err) {
        console.log(err);
        _this4.$toastStore.add({
          title: _this4.$t('restoreError'),
          text: _this4.$t('article.hideErrorText'),
          icon: 'icon-ic-dismiss'
        });
      });
    }
  }
};